var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteHeartCrackFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.94 4.29c-2.06-1.636-4.493-1.62-6.434-.489c-2.095 1.221-3.569 3.7-3.504 6.592C2.14 16.5 10.5 21 12 21s9.861-4.5 9.998-10.607c.065-2.892-1.409-5.37-3.504-6.592a5.76 5.76 0 0 0-2.75-.799L11.37 7.957l2.336 2.336a1 1 0 0 1 .125 1.262l-2 3a1 1 0 0 1-1.664-1.11l1.545-2.318l-2.42-2.42a1 1 0 0 1-.043-1.369z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteHeartCrackFill);
export default __webpack_public_path__ + "static/media/mingcute--heart-crack-fill.396c5eef1bdf9cd30f97c97a75568220.svg";
export { ForwardRef as ReactComponent };